import React from "react";
import { Step, Icon, Affix, Nav } from "@alifd/next";
import './index.less';

const StepItem = Step.Item;

function StepBar(props) {
  const {
    currentStep,
    onClick,
    dataSource,
  } = props;

  return (
    <Step
      current={currentStep}
      shape="arrow"
      className="gov-form-step"
    >
      {
        dataSource.map((item) => {
          return <StepItem
            title={<>{item.hasError ? <Icon type="warning" className="warning-icon" /> : null}{item.name}</>}
            onClick={onClick}
            key={item.id}
            disabled={item.disabled}
          />;
        })
      }
    </Step>
  );
}



const NavItem = Nav.Item;

function NavBar(props) {
  const {
    currentStep,
    onClick,
    dataSource,
  } = props;

  return (
    <Affix className="gov-form-nav">
      <Nav
        direction="hoz"
        header={false}
        footer={false}
        type="normal"
        selectedKeys={dataSource[currentStep]['id']}
        activeDirection={'top'}
      >
        {
          dataSource.map((item, index) => {
            return (
              <NavItem
                onClick={() => { onClick(index); }}
                key={item.id}
                disabled={item.disabled}
              >
                {item.hasError ? <Icon type="warning" className="warning-icon" /> : null}
                {item.name}
              </NavItem>
            );
          })
        }
      </Nav>
    </Affix>
  );
}
export default StepBar;

export {
  NavBar
}
